export const isInteger = (value): boolean | string => {
  return !!Number.isInteger(Number(value)) || 'Integer is required';
};
